// services/bomService.ts

import axios from 'axios';
import { baseUrl, config, requestID } from '../../../common/utils';

export interface MaterialInput {
  materialId: string;
  quantityPerUnit: number;
  unit: string;
}

export interface CreateBOMPayload {
  productId: string;
  quantityToProduce: number;
  materials: MaterialInput[];
}

export interface BOM {
  id: string;
  productId: string;
  productName: string;
  quantityToProduce: number;
  materials: MaterialInput[];
  createdAt: string;
}

export const createBOM = async (payload: CreateBOMPayload) => {
    const res = await axios.post(`${baseUrl()}/api/bom`,
        {
            ...payload,
            requestID: requestID(),
        },
        config);
  return res.data.data;
};

export const getAllProducts = async () => {
    const res = await axios.post(`${baseUrl()}/warehouses/getBarInventory`,
        {
            requestID: requestID(),
        },
        config);
    console.log("Products response:", res);
  return res.data.data;
};



export const getBomInventory = async () => {
    const res = await axios.post(`${baseUrl()}warehouses/getBomInventory`,
        {
            requestID: requestID(),
        },
        config);
    console.log("Products response:", res);
  return res.data.data;
};


export const getBarInventoryByBranch = async () => {
    const res = await axios.post(`${baseUrl()}/warehouses/getBarInventoryByBranch`,
        {
            requestID: requestID(),
        },
        config);
    console.log("Products response:", res);
  return res.data.data;
};




export const getAllBOMs = async (): Promise<BOM[]> => {
    const res = await axios.post(`${baseUrl}/api/bom`,
        {
        requestID: requestID(),
        },
        config);
  return res.data;
};